import { cn } from '../../utils/cn';
import type { LegalConsentLinkProps } from './LegalConsentLine.types';
import { keepOnOneLine } from './link-label';

/**
 * Web anchor for a policy named inside a `LegalConsentLine`.
 *
 * A new tab on purpose: the line sits under a form the user is part-way
 * through, and an in-place navigation would throw away what they typed.
 */
export function LegalConsentLink({
  href,
  children,
  className,
  testID,
}: LegalConsentLinkProps) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={cn('underline hover:text-fg-subtle', className)}
      data-testid={testID}>
      {keepOnOneLine(children)}
    </a>
  );
}
